var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrainAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9282 11.607C21.7262 11.119 21.2932 11.002 21.0002 10.974V8C21.0002 6.897 20.1032 6 19.0002 6H13.0002V4.61C13.3052 4.336 13.5002 3.942 13.5002 3.5C13.5002 3.10218 13.3422 2.72064 13.0609 2.43934C12.7796 2.15804 12.3981 2 12.0002 2C11.6024 2 11.2209 2.15804 10.9396 2.43934C10.6583 2.72064 10.5002 3.10218 10.5002 3.5C10.5002 3.942 10.6952 4.336 11.0002 4.61V6H5.00023C3.89723 6 3.00023 6.897 3.00023 8V10.997L2.91823 11.003C2.66621 11.0212 2.43041 11.1341 2.25825 11.3191C2.08609 11.504 1.99034 11.7473 1.99023 12V14C1.99023 14.2652 2.09559 14.5196 2.28313 14.7071C2.47066 14.8946 2.72502 15 2.99023 15H3.00023V20C3.00023 21.103 3.89723 22 5.00023 22H19.0002C20.1032 22 21.0002 21.103 21.0002 20V15C21.2655 15 21.5198 14.8946 21.7073 14.7071C21.8949 14.5196 22.0002 14.2652 22.0002 14V12.062C22.0117 11.9068 21.9871 11.7511 21.9282 11.607ZM5.00023 20V8H19.0002L19.0012 11.996L19.0002 12V14L19.0012 14.005L19.0022 20H5.00023Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14C9.32843 14 10 13.1046 10 12C10 10.8954 9.32843 10 8.5 10C7.67157 10 7 10.8954 7 12C7 13.1046 7.67157 14 8.5 14Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14C16.3284 14 17 13.1046 17 12C17 10.8954 16.3284 10 15.5 10C14.6716 10 14 10.8954 14 12C14 13.1046 14.6716 14 15.5 14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H16V18H8V16Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainAi);
export default __webpack_public_path__ + "static/media/train-ai.536a4cea84884e0964c2aa331234ff3b.svg";
export { ForwardRef as ReactComponent };